import React, { useState } from "react";
import Axios from "../../axios/axios";

export default function ReceiveAmount({}) {
  // Get the current date
  const today = new Date();

  // Format the date as YYYY-MM-DD (the required format for HTML date input)
  const formattedToday = today.toISOString().split("T")[0];

  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerRes, setResCustomer] = useState("");
  const [searchCustomerCode, setResCustomerCode] = useState("");
  const [customerDetails, setCustomerDetails] = useState();

  const [customer, setCustomer] = useState("");
  const [amount, setAmount] = useState("");
  const [discount, setDiscount] = useState(0);
  const [date, setDate] = useState(formattedToday);
  const [note, setNote] = useState("");
  const [selectedOrder, setOrderSelected] = useState("");

  const [orders, setOrders] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("cash");

  const customerSearchFunction = async (val) => {
    if (searchCustomer === "") {
      setResCustomer("Please enter mobile number");
    } else {
      const { data } = await Axios.get(`/api/user/mob/${searchCustomer}`);

      if (data.code === 400) {
        setResCustomer(data?.message);

        setResCustomerCode(data.code);
      } else {
        setResCustomer(data.user.name);
        setCustomer(data.user._id);
        setCustomerDetails(data);
        await Axios.get(`/api/order/myorders/${data?.user?._id}`).then(
          (res) => {
            setOrders(res.data);
          },
        );
      }
    }
  };

  const getOrderId = (orderId) => {
    let data = orders?.find((data) => data._id === orderId);
    return data.orderId;
  };
  const [loader, setLoader] = useState(false);
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoader(true);

    if (!customerDetails?.user) return;

    try {
      // 1️⃣ OPTIONAL: keep existing transaction (if you still use it)
      let data = {
        amount: customerDetails?.user?.balanceAmount,
        discount,
        receive: amount,
        date,
        note,
        customer,
        orderId: selectedOrder,
        order: getOrderId(selectedOrder),
      };

      await Axios.post(`/api/user/trans/`, data);

      // 2️⃣ 🔥 ADD THIS (MAIN FIX)
      if (amount > 0 && selectedOrder) {
        await Axios.post(`/api/order/add-payment`, {
          orderId: selectedOrder,
          amount: Number(amount),
          paymentMethod,
          module: "manual",
          note,
        });
      }

      // 3️⃣ REDIRECT
      window.location.href = `/user/${customer}`;
    } catch (err) {
      console.error(err);
    }

    setLoader(false);
  };
  return (
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      backdrop={true}
      data-backdrop="static"
    >
      {" "}
      <form class="forms-sample" onSubmit={submitHandler}>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Receive Amount
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="exampleInputName">Search Customer here</label>
                <div class="row">
                  <div class="col-10">
                    {" "}
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Search number here"
                      onChange={(e) => setSearchCustomer(e.target.value)}
                    />
                  </div>
                  <div class="col-2">
                    <i
                      className="icon-search mx-0 pointer"
                      onClick={customerSearchFunction}
                    ></i>
                  </div>
                  <div className="p-3">
                    {" "}
                    {searchCustomerRes} [ Balance :{" "}
                    <b>₹ {customerDetails?.user?.balanceAmount} ] </b>
                  </div>
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Order</label>
                  <select
                    class="form-control"
                    onChange={(e) => setOrderSelected(e.target.value)}
                    value={selectedOrder}
                  >
                    <option value="">Select Order</option>
                    {orders?.map((data) => (
                      <option value={data._id}>ADC_{data.orderId}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Amount</label>
                <input
                  type="number"
                  class="form-control"
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Amount"
                  value={amount}
                  name="amount"
                  required={true}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Discount</label>

                <input
                  type="number"
                  class="form-control"
                  onChange={(e) => setDiscount(e.target.value)}
                  placeholder="Discount"
                  value={discount}
                  min={0}
                  name="discount"
                  required={true}
                />
              </div>
              <div className="form-group">
                <label>Payment Method</label>
                <select
                  className="form-control"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  <option value="cash">Cash</option>
                  <option value="upi">UPI</option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputName">Date</label>
                <input
                  type="date"
                  class="form-control"
                  onChange={(e) => setDate(e.target.value)}
                  placeholder="name"
                  value={date}
                  name="date"
                  required={true}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Note</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Notes"
                  value={note}
                  name="note"
                  required={true}
                />
              </div>
            </div>

            {loader ? (
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
              </div>
            ) : (
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" class="btn btn-primary">
                  Save changes
                </button>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}
